import { List } from "./List";
import { CreateForm } from "./CreateForm";
import { EditForm } from "./EditForm";

export default {
  List,
  CreateForm,
  EditForm,
};
